import React from 'react';
import App from './components/App.jsx';
import createApp from '@shopify/app-bridge';
import { createRoot } from 'react-dom/client';

const config = window.appBridgeConfig;

window.app = createApp(config);
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import '@shopify/polaris/build/esm/styles.css';

const container = document.getElementById('app');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App config={config} />);
